import React, { useEffect } from 'react';

const ApplyCSSOverrides = (props) => {
  useEffect(() => {
    // Define the CSS rules as a string
    const cssRules = `
      #meeting-info-indication {
        display: none !important;
      }
      .meeting-info-container {
        display: none !important;
      }
      .page-footer {
        display: none !important;
      }
      #raisehand {
        display: none !important;
      }
      .SvgHand {
        display: none !important;
      }  
      a[aria-label="Raise Hand"] {
        display: none !important;
      }
      a[aria-label="React"] {
        display: none !important;
      }
      .footer__button-wrap[feature-type="raiseHand"] {
        display: none;
      }
      .footer__button-wrap[feature-type="reaction"] {
        display: none;
      }
      .settings-skin-tone-section__container {
        display: none !important;
      }
      .wr-schedule-date {
        display: none !important;
      }
      .about__footer {
        display: none !important;;
      }

    `;
    const cssRulesMeeting = `
    #meeting-info-indication {
        display: none !important;
      }
      .meeting-info-container {
        display: none !important;
      }
      .footer__button-wrap[feature-type="newLTT"] {
        display: none;
      }
      a[aria-label="Captions"] {
        display: none !important;
      }
      .about__footer {
        display: none !important;;
      }

  `;

    // Create a <style> element
    const styleElement = document.createElement('style');
    styleElement.textContent = props?.type==='webinar'?cssRules:cssRulesMeeting;

    // Append the <style> element to the document head
    document.head.appendChild(styleElement);

    // Cleanup function to remove the <style> element on component unmount
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []); // Empty dependency array ensures this runs only once

  return null; // This component does not render anything visible
};

export default ApplyCSSOverrides;